import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, Units, centsToUnits } from '@systemeio/ui';
import { ChartData, ScatterDataPoint } from 'chart.js';
import ChartBox from 'modules/main/components/chart-box-section/chart-box';
import ChartsSkeleton from 'modules/main/components/chart-box-section/charts-skeleton';
import { options } from 'modules/main/components/chart-box-section/constants';
import { ChartBoxSectionProps } from 'modules/main/components/chart-box-section/types';
import { useMain } from 'modules/main/hooks/use-main';
import { MainRevenueInterface, MainRevenueItemInterface } from 'modules/main/types/main-interface';
import { getChartconfig } from 'modules/management/email-delivery-statistics/util/get-chart-config';
import { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
import { toShortDate } from 'shared/utils/date-time-format';
export interface RevenueChartBoxProps extends ChartBoxSectionProps {}
export const RevenueChartBox = t0 => {
  const $ = _c(13);
  const {
    filter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    revenue
  } = useMain(filter);
  const {
    user,
    intlLocale
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [revenueData, setRevenueData] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== intlLocale || $[2] !== revenue) {
    t2 = () => {
      if (revenue) {
        setRevenueData((Object.keys(revenue) as Array<keyof MainRevenueInterface>).sort((a, b) => revenue[b].total - revenue[a].total).map(key => ({
          currency: key,
          data: revenue[key],
          chartData: getChartconfig({
            type: "line",
            labels: revenue[key].values.map(value => toShortDate(value.date, intlLocale)),
            data: revenue[key].values.map(_temp)
          })
        })));
      }
    };
    t3 = [revenue, intlLocale];
    $[1] = intlLocale;
    $[2] = revenue;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== filter || $[6] !== revenue || $[7] !== revenueData || $[8] !== t || $[9] !== user?.dashboardLocale) {
    t4 = revenue ? revenueData.map((rev, idx) => <ChartBox key={idx} title={t("dashboard.main.sales").toUpperCase()} total={currencyFormat(Math.round(centsToUnits(rev.data.total)) as Units, rev.currency, user?.dashboardLocale, true)} diffPercents={rev.data.diffPercents} countDays={rev.data.countDays} dateSince={filter.dateSince} chart={<Line height={200} data={rev.chartData} options={options} />} />) : <ChartsSkeleton />;
    $[5] = filter;
    $[6] = revenue;
    $[7] = revenueData;
    $[8] = t;
    $[9] = user?.dashboardLocale;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <>{t4}</>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(el) {
  return Math.round(el.value / 100);
}